module.exports = __webpack_public_path__ + "img/33.2382aaa3.png";